<template>
  <div>
    <div class="header_top media_display" v-if="unReadnum>0" @click="openNews">
      <div class="container_box header_top allnewsdot" style="text-align: right;">
        <div class="newsdot" >
          {{unReadnum}}
        </div>          
      </div>
    </div>
    
    <div class="news-remind" v-if="wsDetail!=''">
      <img src = "../assets/images/close2.png" @click="closeNewremind">
      <div @click="openNews">
        <div style="padding-right:40px;">{{wsDetail.content}}</div>
        <div class="time">{{wsDetail.createTime}}</div>
      </div>     
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      ws:null,
      ws2:null,
      unReadnum:'',
      wsDetail:[],
     }
  },
  methods: {
    getNewsremind(){      
      if(!localStorage.getItem('id')){
        return
      }
      var that =this;
      var ws = new WebSocket(localStorage.getItem('root_path2')+'/noAuth/ws/'+localStorage.getItem('id')); 
      var ws2= new WebSocket(localStorage.getItem('root_path2')+'/noAuth/ws-unread/'+localStorage.getItem('id'));  
      ws.onopen = function(res){      
        ws.onmessage= function(res){          
          that.wsDetail =JSON.parse(res.data);  
          $('.news-remind').css('display',"block");             
        }
      }
      ws2.onopen = function(res){
        ws2.send("1");  
        ws2.onmessage=function(res){
          that.unReadnum =JSON.parse(res.data); 
          sessionStorage.setItem('unReadnum',that.unReadnum)           
        }
     };

     // 路由跳转时结束websocket链接
     this.$router.afterEach(function () {
       ws.close();
       ws2.close();
       $('.news-remind').css('display',"none");
     }) 
    },
    getLoad(){
      var that =this;
      this.$router.afterEach(function () {
        that.getNewsremind();
     }) 
    },
    //打开消息
    openNews(){
      if(localStorage.getItem('type')==3){     
        window.sessionStorage.setItem("personCenterType",2)
        this.$router.push({path:'/person-center'});
      }
      if(localStorage.getItem('type')!=3){
        window.sessionStorage.setItem("enterCenterType",7)
        this.$router.push({path:'/enter-center'});
      }
    },
    closeNewremind(){
      $('.news-remind').css('display',"none");
    }
  },
  destroyed () {
    // this.closeWebSocket();
  },
  created(){
    // this.getNewsremind();
    // this.getLoad();
  }


};
</script>



// WEBPACK FOOTER //
// src/components/socket.vue